import type { DialogOptions, DialogService } from '@patsnap/tahiti-core';

export const ShareLinkDialogService = Symbol('ShareLinkDialogService');

/**
 * 分享链接对话框服务接口
 * @description 用于打开分享链接对话框
 */
export interface ShareLinkDialogService extends DialogService<ShareLinkDialogOptions, void> {
    /**
     * 打开分享链接对话框
     * @param options - 对话框选项
     * @returns Promise<void>
     */
    open(options: ShareLinkDialogOptions): Promise<void>;
}

/**
 * 分享链接对话框选项
 */
export interface ShareLinkDialogOptions extends DialogOptions {
    /**
     * 密码保护（可选）
     */
    password?: string;
}
